import CategoryPage from "./CategoryPage";
const HERO = "https://images.unsplash.com/photo-1762117360871-f11fbad00ee1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjB2aWxsYSUyMGV4dGVyaW9yJTIwc3Vuc2V0fGVufDB8fHx8MTc3ODEwNjQwMHww&ixlib=rb-4.1.0&q=85";
export default function LocationSaisonniere() {
  return <CategoryPage category="rental_short" heroImage={HERO} titleKey="rentalShort" />;
}
